<template>
  <div class="settings-page">
    <!-- 背景装饰 -->
    <div class="page-bg">
      <div class="bg-orb orb-1"></div>
      <div class="bg-orb orb-2"></div>
      <div class="bg-orb orb-3"></div>
    </div>

    <div class="page-container">
      <!-- ===== 顶部导航 ===== -->
      <div class="settings-header">
        <button class="btn-back" @click="handleBack">
          <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
           <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          {{ $t("setting.back") }}
        </button>
        <h1 class="settings-title">{{ $t("setting.title") }}</h1>
        <div class="header-placeholder"></div>
      </div>

      <!-- ===== 主体：左侧菜单 + 右侧内容 ===== -->
      <div class="settings-body">
        <!-- 左侧菜单 -->
        <div class="settings-sidebar">
          <div
            v-for="item in menuItems"
            :key="item.key"
            class="menu-item"
            :class="{ active: currentMenu === item.key }"
            @click="switchMenu(item.key)"
          >
            <span class="menu-icon">{{ item.icon }}</span>
            <span class="menu-label">{{ item.label }}</span>
          </div>
        </div>

        <!-- 右侧内容区 -->
        <div class="settings-content">


          <!-- ===== 个人信息 ===== -->
          <ProfilePanel v-show="currentMenu === 'profile'" :profile="profile" />

          <!-- ===== 账号安全 ===== -->
          <SecurityPanel
            v-show="currentMenu === 'security'"
            :profile="profile"
            :twofa.sync="twofa"
          />

          <!-- ===== 账号认证 ===== -->
          <VerifyPanel v-show="currentMenu === 'verify'" :profile="profile" />

          <!-- ===== 修改密码 ===== -->
          <ChangePwdPanel
            v-show="currentMenu === 'changePwd'"
            :isTwoFactor="profile.is_two_factor"
            @go-security="goToSecurity"
          />

          <!-- ===== 交易密码 ===== -->
          <TradePwdPanel
            v-show="currentMenu === 'tradePwd'"
            :isTwoFactor="profile.is_two_factor"
            @go-security="goToSecurity"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfilePanel from "@/components/setting/ProfilePanel.vue";
import SecurityPanel from "@/components/setting/SecurityPanel.vue";
import VerifyPanel from "@/components/setting/VerifyPanel.vue";
import TradePwdPanel from "@/components/setting/TradePwdPanel.vue";
import ChangePwdPanel from "@/components/setting/ChangePwdPanel.vue";

export default {
  name: "SettingsPage",
  components: {
    ProfilePanel,
    SecurityPanel,
    VerifyPanel,
    TradePwdPanel,
    ChangePwdPanel,
  },
  data() {
    return {
      currentMenu: "profile",
      menuItems: [
        { key: "profile", label: this.$t("setting.menuProfile"), icon: "👤" },
        { key: "security", label: this.$t("setting.menuSecurity"), icon: "🔐" },
        { key: "verify", label: this.$t("setting.menuVerify"), icon: "🪪" },
        { key: "changePwd", label: this.$t("setting.menuChangePwd"), icon: "🔑" },
        { key: "tradePwd", label: this.$t("setting.menuTradePwd"), icon: "💰" },
      ],
      profile: {},
      twofa: {
        enabled: false,
      },
    };
  },
  created() {
    this.getUserInfo();
    // 判断 URL 是否有 tab 参数，有则切换到对应菜单
    const tab = this.$route.query.tab;
    if (tab) {
      const exists = this.menuItems.some((item) => item.key === tab);
      if (exists) {
        this.currentMenu = tab;
      }
    }
  },
  watch: {
    // 监听 URL 的 tab 参数变化（例如点击顶部菜单跳转到 /setting?tab=security）
    "$route.query.tab"(newTab) {
      if (newTab) {
        const exists = this.menuItems.some((item) => item.key === newTab);
        if (exists) {
          this.currentMenu = newTab;
        }
      }
    },
  },

  methods: {
    getUserInfo() {


      this.$api.user.getUserInfo().then((res) => {
        if (res.code === 1) {
          this.$message.error(res.msg || this.$t("setting.getUserInfoFail"));
          return;
        }
        this.profile = res.data;

        //是否开启两步验证
        if (this.profile.is_two_factor == 2) {
          this.twofa.enabled = true;
        }
      });
    },
    switchMenu(key) {
      this.currentMenu = key;
      // 同步更新 URL 的 tab 参数
      this.$router
        .replace({ name: "Setting", query: { tab: key } })
        .catch(() => {});
    },
    // 跳转到账号安全菜单（开启两步验证）
    goToSecurity() {
      this.currentMenu = "security";
      // 同步更新 URL 的 tab 参数
      this.$router
        .replace({ name: "Setting", query: { tab: "security" } })
        .catch(() => {});
    },



    handleBack() {
      console.log("返回个人中心");
      this.$router.push("/member");
    },
  },
};
</script>

<style scoped>
/* ===== 页面容器 ===== */
.settings-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: #0a0e1a;
  padding: 40px 20px;
}

/* ===== 背景装饰 ===== */
.page-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.bg-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.2;
}

.orb-1 {
  width: 500px;
  height: 500px;
  background: #0066ff;
  top: -200px;
  right: -100px;
}

.orb-2 {
  width: 400px;
  height: 400px;
  background: #7c3aed;
  bottom: -150px;
  left: -100px;
}

.orb-3 {
  width: 300px;
  height: 300px;
  background: #00b4ff;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.06;
}

.page-container {
  max-width: 1100px;
  width: 100%;
  position: relative;
  z-index: 1;
}

/* ===== 顶部导航 ===== */
.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.btn-back {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 8px 18px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-back:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.settings-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}

.header-placeholder {
  width: 80px;
}

/* ===== 主体布局 ===== */
.settings-body {
  display: flex;
  gap: 24px;
  background: rgba(255, 255, 255, 0.04);
  backdrop-filter: blur(20px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  padding: 24px;
  min-height: 500px;
}

/* ===== 左侧菜单 ===== */
.settings-sidebar {
  width: 180px;
  flex-shrink: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  padding-right: 16px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
}

.menu-item:hover {
  color: rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.04);
}

.menu-item.active {
  color: #fff;
  background: linear-gradient(
    135deg,
    rgba(0, 180, 255, 0.15),
    rgba(0, 100, 255, 0.08)
  );
  border: 1px solid rgba(0, 180, 255, 0.15);
}

.menu-icon {
  font-size: 16px;
}

.menu-label {
  font-size: 14px;
}

/* ===== 右侧内容 ===== */
.settings-content {
  flex: 1;
  padding: 0 8px 0 20px;
  min-height: 400px;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .settings-body {
    flex-direction: column;
    padding: 16px;
  }
  .settings-sidebar {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    padding-right: 0;
    padding-bottom: 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
  }
  .menu-item {
    padding: 8px 14px;
    font-size: 13px;
    margin-bottom: 0;
  }
  .settings-content {
    padding: 16px 0 0 0;
  }
  .settings-header {
    flex-wrap: wrap;
    gap: 12px;
  }
  .header-placeholder {
    display: none;
  }
}

@media (max-width: 480px) {
  .settings-page {
    padding: 16px 10px;
  }
  .settings-title {
    font-size: 18px;
  }
  .btn-back {
    padding: 6px 14px;
    font-size: 13px;
  }
  .menu-item {
    padding: 6px 12px;
    font-size: 12px;
  }
  .menu-icon {
    font-size: 14px;
  }
}
</style>
